var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
export default React.memo(function (props) {
    return (React.createElement("svg", __assign({ width: 48, height: 48, viewBox: "0 0 48 48", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M14.098 15L33 34.413 31.902 35 13 15.587 14.098 15zm2.204 5.412L28.74 33.186c-.61.75-2.237 1.267-4.25 1.552l-.628.08c-2.13.243-4.595.243-6.724 0l-.628-.08C13.94 34.374 12 33.632 12 32.51c0-2.628 2.386-4.862 5.71-5.679a4.847 4.847 0 01-2.067-3.974c0-.892.24-1.727.66-2.445zM27.5 13a4.857 4.857 0 012.791 8.833c3.323.815 5.709 3.05 5.709 5.677 0 1.122-1.94 1.864-4.51 2.228l-.628.08c-.281.032-.568.06-.86.084l-4.13-4.244a6.06 6.06 0 00-3.185-8.451A4.857 4.857 0 0127.5 13zm-7 5a4.857 4.857 0 014.478 6.74l-6.241-6.41A4.845 4.845 0 0120.5 18z", fill: "currentColor", fillRule: "nonzero", stroke: "none", strokeWidth: 1 })));
});
